export const downloadFile = async (downloadPath: string, fileName: string) => {
  const link = document.createElement('a');
  link.download = fileName;
  link.href = downloadPath;
  link.click();
};

export const viewFile = async (viewPath: string) => {
  const link = document.createElement('a');
  link.href = viewPath;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.click();
};
